import React from 'react';
import { FETCH_ORGANISATION, FETCH_ORGANISATION_SUCCESS, FETCH_ORGANISATION_FAILER, FETCH_SLA, FETCH_SLA_SUCCESS, FETCH_SLA_FAILER } from './SLAActionTypes'

export const fetchOrganisationRequest = () => {
    return {
        type: FETCH_ORGANISATION
    }
}

export const fetchOrganisationSuccess = (data: any) => {
    return {
        type: FETCH_ORGANISATION_SUCCESS,
        payload: data
    }
}


export const fetchOrganisationFailer = (errorMsg: any) => {
    return {
        type: FETCH_ORGANISATION_FAILER,
        payload: errorMsg
    }
}


export const fetchSlaRequest = () => {
    return {
        type: FETCH_SLA
    }
}

export const fetchSlaSuccess = (data: any) => {
    return {
        type: FETCH_SLA_SUCCESS,
        payload: data
    }
}


export const fetchSlaFailer = (errorMsg: any) => {
    return {
        type: FETCH_SLA_FAILER,
        payload: errorMsg
    }
}


